// ImportantDatesTicker.jsx
// Inspired by CAPPC's compliance deadline ticker strip.
// Displays a horizontally auto-scrolling list of upcoming tax deadlines.

const dates = [
  { label: "QRMP Scheme opt-in/out for April–June quarter", due: "30 Apr 2026" },
  { label: "TDS payment for March (Salary & Non-Salary)", due: "30 Apr 2026" },
  { label: "TDS/TCS deposit by Govt. offices (book entry) for March", due: "30 Apr 2026" },
  { label: "TDS u/s 194-IA on property purchase payments for March", due: "30 Apr 2026" },
  { label: "TDS u/s 194-IB on rent payments exceeding ₹50,000/mo for March", due: "30 Apr 2026" },
  { label: "TDS u/s 194M for individual/HUF payments for March", due: "30 Apr 2026" },
  { label: "TDS u/s 194S on Virtual Digital Assets for March", due: "30 Apr 2026" },
  { label: "Upload Form 15G/15H declarations for March quarter", due: "30 Apr 2026" },
  { label: "GST Monthly Return (GSTR-3B) for March", due: "20 May 2026" },
  { label: "TDS Certificate (Form 16A) for Q4 FY 2025–26", due: "15 Jun 2026" },
];

function DatePill({ label, due }) {
  return (
    <span className="inline-flex items-center gap-3 whitespace-nowrap">
      <span className="w-1.5 h-1.5 rounded-full bg-gold flex-shrink-0" />
      <span className="font-manrope text-[12px] text-white/80">{label}</span>
      <span className="font-manrope text-[11px] font-bold text-gold bg-gold/10 border border-gold/20 px-2 py-0.5 rounded-full">
        {due}
      </span>
    </span>
  );
}

export default function ImportantDatesTicker() {
  // Duplicate for seamless infinite scroll
  const doubled = [...dates, ...dates];

  return (
    <div className="bg-navy border-b border-white/5 overflow-hidden">
      <div className="max-w-[1280px] mx-auto px-6 py-0 flex items-center">
        {/* Static label */}
        <div className="flex-shrink-0 flex items-center gap-2 pr-6 border-r border-white/10 py-3">
          <span className="material-symbols-outlined text-gold text-[16px]">event</span>
          <span className="font-manrope text-[10px] font-bold tracking-[0.2em] uppercase text-gold whitespace-nowrap">
            Important Dates
          </span>
        </div>

        {/* Scrolling track */}
        <div className="overflow-hidden flex-1">
          <div
            className="flex gap-12 py-3"
            style={{
              animation: "ticker-scroll 40s linear infinite",
              width: "max-content",
            }}
          >
            {doubled.map((d, i) => (
              <DatePill key={i} label={d.label} due={d.due} />
            ))}
          </div>
        </div>
      </div>

      {/* Keyframe injected inline — move to index.css if preferred */}
      <style>{`
        @keyframes ticker-scroll {
          0%   { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        @media (prefers-reduced-motion: reduce) {
          .ticker-scroll { animation: none; }
        }
      `}</style>
    </div>
  );
}
